import {
  Delivery,
  Vehicle,
  Window,
  VehicleRoutingSolution,
} from './VehicleRoutingSolution';
import { nonEmptyLines } from './utils';
import { EditedVehicle } from './generalTypes';

function getAllDeliveriesMap(
  solutionFile: VehicleRoutingSolution
): Map<number, Delivery> {
  return new Map(
    solutionFile.vehicles
      .flatMap(vehicle => vehicle.deliveries)
      .map(delivery => [delivery.orderId, delivery])
  );
}

function getOriginalVehiclesMap(
  solutionFile: VehicleRoutingSolution
): Map<number, Vehicle> {
  return new Map(
    solutionFile.vehicles.map(vehicle => [
      vehicle.courierId || vehicle.placeholderId,
      vehicle,
    ])
  );
}

export function getUpdatedSolution(
  solutionFile: VehicleRoutingSolution,
  editedVehicles: EditedVehicle[]
): VehicleRoutingSolution {
  const allDeliveries = getAllDeliveriesMap(solutionFile);
  const originalVehicles = getOriginalVehiclesMap(solutionFile);

  const updatedVehicles: Vehicle[] = editedVehicles.map(vehicle => ({
    ...originalVehicles.get(vehicle.courierId),
    deliveries: nonEmptyLines(vehicle.orderIds)
      .map(line => parseInt(line))
      .map(orderId => allDeliveries.get(orderId)),
  }));
  return {
    ...solutionFile,
    vehicles: updatedVehicles,
  };
}

export function shortWindowString(window: Window): string {
  return `${shortLocalTime(window.start)}-${shortLocalTime(window.end)}`;
}

function shortLocalTime(isoTimeString: string): string {
  return new Date(isoTimeString).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Oslo',
  });
}
